<template>
  <div class="main" v-cloak>
    <!-- 优化后的 Loading 遮罩 -->
    <div v-if="!isAppLoaded" class="loading-overlay">
      <div class="loading-content">
        <div class="premium-spinner"></div>
        <p class="loading-text">{{ t("vip.loading") || 'Loading...' }}</p>
      </div>
    </div>

    <!-- 主展示区，使用 v-if 确保 CSS 未加载前不输出 HTML -->
    <div v-if="isAppLoaded" id="app-content" class="main-content-wrapper">

      <!-- 顶部通栏 -->
      <section class="top">
        <router-link class="top-link" :to="payCenterURL">{{ t("vip.navLink") }}</router-link>

        <div class="top-avatar">
          <template v-if="!isLogin">
            <a href="javascript:" @click.prevent="onShow('isShowLogin')">
              <img :src="`${baseUrl}images/vip-center/icon-appavatar.png`" alt="" />
            </a>
          </template>
          <template v-else>
            <a href="javascript:" @click.prevent="onShow('isShowLogout')">
              <img :src="`${baseUrl}images/vip-center/icon-appavatar2.png`" alt="" />
            </a>
          </template>
        </div>
      </section>

      <!-- 中间主要内容 -->
      <main class="container">
        <!-- 头部标题 -->
        <hgroup class="heading-group">
          <h1>CITY OF CRIME</h1>
          <h2>{{ t("vip.title") }}</h2>
        </hgroup>

        <!-- 用户信息 -->
        <section class="user-box">
          <header>
            <!-- 未登录用户显示 -->
            <template v-if="!isLogin">
              <div class="user-avatar">
                <img :src="`${baseUrl}images/vip-center/user-avatar.png`" alt="Avatar" />
              </div>
              <div class="user-info">
                <a
                  class="btn-mid-yellow"
                  href="javascript:"
                  @click.prevent="onShow('isShowLogin')"
                >
                  {{ t("vip.login") }}
                </a>
              </div>
              <div class="user-level">
                <img :src="`${baseUrl}images/vip-center/icon-vip.png`" alt="VIP" />
              </div>
            </template>
            <!-- 已登录用户显示 -->
            <template v-else>
              <div class="user-avatar">
                <img :src="userInfo.headPic" alt="Avatar" />
              </div>
              <div class="user-info">
                <h2>{{ userInfo.roleName }}</h2>
                <h3>
                  <span>{{ t("vip.userLevel") }}:{{ userInfo.level }}</span>
                  <span>{{ t("vip.userServer") }}:{{ userInfo.serverId }}</span>
                </h3>
              </div>
              <div class="user-level">
                <img :src="currentVipInfo.vipLevelImg" alt="" />
              </div>
            </template>
          </header>

          <!-- 升级进度条 -->
          <footer>
            <!-- 未登录用户显示 -->
            <template v-if="!isLogin">
              <div class="upgrade-info">
                <div class="upgrade-progress"></div>
              </div>
            </template>
            <!-- 已登录用户显示 -->
            <template v-else>
              <div class="upgrade-info">
                <p v-if="vipLevel == 0">
                  {{ t("vip.couponDescription4") }}
                </p>
                <p v-else>
                  {{ t("vip.purchase") }} {{ currentVipInfo.exprience }}
                  <i class="ico-coin"></i> {{ t("vip.upgradeVIP") }}
                </p>
                <div v-if="vipLevel == 0" class="upgrade-progress">
                  <div class="text">
                    0/1
                  </div>
                  <div class="yellow" :style="{ width: '0%' }"></div>
                </div>
                <div v-else class="upgrade-progress">
                  <div class="text">
                    {{ currentUserVipExp }}/{{ currentVipInfo.exprience }}
                  </div>
                  <div class="yellow" :style="{ width: currentProgress }"></div>
                </div>
              </div>
              <div class="upgrade-aside">
                <router-link class="btn-lg-yellow" :to="payCenterURL">{{ t("vip.upgrade") }}</router-link>

              </div>
            </template>
          </footer>
        </section>

        <!-- VIP等级优惠说明 -->
        <section class="vip-benefits">
          <h2>{{ t("vip.benefitsTitle") }}</h2>
          <!-- 移动端显示 -->
          <template v-if="isMobile">
            <div
              id="vipSwiper"
              class="vip-benefits-swiper"
              :style="{ opacity: isSwiperLoaded ? 1 : 0 }"
            >
              <div class="swiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '1' }"
                  >
                    <div class="wrap">
                      <h2>VIP 1</h2>
                      <h3>{{ t("vip.benefitsCondition") }}</h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x1</div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-user"></i></div>
                        <div class="row-text" :style="{ height: swiperItemHeight }">
                          {{ t("vip.benefitsItem2") }}
                        </div>
                        <div class="row-aside">x1</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '2' }"
                  >
                    <div class="wrap">
                      <h2>VIP 2</h2>
                      <h3>{{ t("vip.purchase") }} 60000 <i class="ico-coin-sm"></i></h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x2</div>
                      </div>
                      <div
                        class="row row-null"
                        :style="{ height: swiperItemHeight }"
                      >
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '3' }"
                  >
                    <div class="wrap">
                      <h2>VIP 3</h2>
                      <h3>{{ t("vip.purchase") }} 150000 <i class="ico-coin-sm"></i></h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x3</div>
                      </div>
                      <div
                        class="row row-null"
                        :style="{ height: swiperItemHeight }"
                      >
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '4' }"
                  >
                    <div class="wrap">
                      <h2>VIP 4</h2>
                      <h3>{{ t("vip.purchase") }} 300000 <i class="ico-coin-sm"></i></h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x4</div>
                      </div>
                      <div
                        class="row row-null"
                        :style="{ height: swiperItemHeight }"
                      >
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '5' }"
                  >
                    <div class="wrap">
                      <h2>VIP 5</h2>
                      <h3>{{ t("vip.purchase") }} 600000 <i class="ico-coin-sm"></i></h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x5</div>
                      </div>
                      <div
                        class="row row-null"
                        :style="{ height: swiperItemHeight }"
                      >
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '6' }"
                  >
                    <div class="wrap">
                      <h2>VIP 6</h2>
                      <h3>{{ t("vip.purchase") }} 1200000 <i class="ico-coin-sm"></i></h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x6</div>
                      </div>
                      <div
                        class="row row-null"
                        :style="{ height: swiperItemHeight }"
                      >
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '7' }"
                  >
                    <div class="wrap">
                      <h2>VIP 7</h2>
                      <h3>{{ t("vip.purchase") }} 2400000 <i class="ico-coin-sm"></i></h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x6</div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-red"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem4") }}</div>
                        <div class="row-aside">x1</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide"
                    :class="{ active: currentVIPLevel == '8' }"
                  >
                    <div class="wrap">
                      <h2>VIP 8</h2>
                      <h3>{{ t("vip.purchase") }} 3600000 <i class="ico-coin-sm"></i></h3>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                        <div class="row-aside"><i class="ico-coin-sm"></i></div>
                      </div>
                      <div class="row">
                        <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                        <div class="row-aside">x6</div>
                      </div>
                      <div id="highestItem" class="row">
                        <div class="row-ico"><i class="ico-coupon-red"></i></div>
                        <div class="row-text">{{ t("vip.benefitsItem4") }}</div>
                        <div class="row-aside">x2</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 分页器 -->
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </template>

          <!-- PC端显示 -->
          <template v-else>
            <ul class="list-benefits">
              <li :class="{ active: currentVIPLevel == '1' }">
                <div class="wrap">
                  <h2>VIP 1</h2>
                  <h3>{{ t("vip.benefitsCondition") }}</h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-user"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem2") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                </div>
              </li>
              <li :class="{ active: currentVIPLevel == 2 }">
                <div class="wrap">
                  <h2>VIP 2</h2>
                  <h3>{{ t("vip.purchase") }} 60000 <i class="ico-coin-sm"></i></h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x2</div>
                  </div>
                  <div class="row row-null">
                    <div class="row-ico"><i class="ico-coupon-user"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem2") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                </div>
              </li>
              <li :class="{ active: currentVIPLevel == '3' }">
                <div class="wrap">
                  <h2>VIP 3</h2>
                  <h3>{{ t("vip.purchase") }} 150000 <i class="ico-coin-sm"></i></h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x3</div>
                  </div>
                  <div class="row row-null">
                    <div class="row-ico"><i class="ico-coupon-user"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem2") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                </div>
              </li>
              <li :class="{ active: currentVIPLevel == '4' }">
                <div class="wrap">
                  <h2>VIP 4</h2>
                  <h3>{{ t("vip.purchase") }} 300000 <i class="ico-coin-sm"></i></h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x4</div>
                  </div>
                  <div class="row row-null">
                    <div class="row-ico"><i class="ico-coupon-user"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem2") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                </div>
              </li>
              <li :class="{ active: currentVIPLevel == '5' }">
                <div class="wrap">
                  <h2>VIP 5</h2>
                  <h3>{{ t("vip.purchase") }} 600000 <i class="ico-coin-sm"></i></h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x5</div>
                  </div>
                  <div class="row row-null">
                    <div class="row-ico"><i class="ico-coupon-red"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem4") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                </div>
              </li>
              <li :class="{ active: currentVIPLevel == '6' }">
                <div class="wrap">
                  <h2>VIP 6</h2>
                  <h3>{{ t("vip.purchase") }} 1200000 <i class="ico-coin-sm"></i></h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x6</div>
                  </div>
                  <div class="row row-null">
                    <div class="row-ico"><i class="ico-coupon-red"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem4") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                </div>
              </li>
              <li :class="{ active: currentVIPLevel == '7' }">
                <div class="wrap">
                  <h2>VIP 7</h2>
                  <h3>{{ t("vip.purchase") }} 2400000 <i class="ico-coin-sm"></i></h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x6</div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-red"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem4") }}</div>
                    <div class="row-aside">x1</div>
                  </div>
                </div>
              </li>
              <li :class="{ active: currentVIPLevel == '8' }">
                <div class="wrap">
                  <h2>VIP 8</h2>
                  <h3>{{ t("vip.purchase") }} 3600000 <i class="ico-coin-sm"></i></h3>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-coin"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem1") }} +3%</div>
                    <div class="row-aside"><i class="ico-coin-sm"></i></div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-blue"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem3") }}</div>
                    <div class="row-aside">x6</div>
                  </div>
                  <div class="row">
                    <div class="row-ico"><i class="ico-coupon-red"></i></div>
                    <div class="row-text">{{ t("vip.benefitsItem4") }}</div>
                    <div class="row-aside">x2</div>
                  </div>
                </div>
              </li>
            </ul>
          </template>
        </section>

        <!-- VIP权益说明 -->
        <section class="vip-info">
          <h2>{{ t("vip.vipInfoTitle") }}</h2>
          <article class="article-black">
            <template v-if="typeof htmlText1 === 'object' && htmlText1 !== null">
              <p v-for="(item, index) in htmlText1" :key="index">
                {{ item }}
              </p>
            </template>
            <template v-else-if="typeof htmlText1 === 'string'">
              <p>{{ htmlText1 }}</p>
            </template>
          </article>
        </section>
      </main>

      <!-- 弹层 登录 -->
      <div class="mask" v-show="popup.isShowLogin">
        <div class="mask-box">
          <header class="mask-header">
            <h2>{{ t("vip.login") }}</h2>
            <a
              class="btn-close"
              href="javascript:"
              @click.prevent="onHide('isShowLogin')"
            ></a>
          </header>
          <article class="mask-body">
            <div class="center ft-red" v-show="formData.isShowError">
              {{ tipMessage }}
            </div>
            <div class="login-box">
              <div class="login-header">
                <input
                  type="text"
                  name="userID"
                  v-model.trim="formData.userID"
                  :placeholder="t('vip.enterID')"
                />
              </div>
              <div class="login-note" style="margin-top: 10px; opacity: 0.8; font-size: 14px;">{{ t("vip.uidTips") }}</div>
            </div>
            <div class="mt center">
              <a v-if="isLoading" class="btn-lg-gray" href="javascript:">
                {{ t("vip.loading") }}
              </a>
              <a
                v-else
                class="btn-lg-yellow"
                href="javascript:"
                @click.prevent="onLogin"
              >
                {{ t("vip.login") }}
              </a>
            </div>
          </article>
        </div>
      </div>

      <!-- 弹层 退出登录 -->
      <div class="mask" v-show="popup.isShowLogout">
        <div class="mask-box">
          <header class="mask-header">
            <h2>&nbsp;</h2>
            <a
              class="btn-close"
              href="javascript:"
              @click.prevent="onHide('isShowLogout')"
            ></a>
          </header>
          <article class="mask-body">
            <div class="mt center">
              <a
                class="btn-lg-yellow"
                href="javascript:"
                @click.prevent="onLogout"
              >
                {{ t("vip.logout") }}
              </a>
            </div>
          </article>
        </div>
      </div>

      <!-- 弹层 经验获取记录 -->
      <div class="mask" v-show="popup.isShowRecord">
        <div class="mask-box" style="max-width: 800px">
          <header class="mask-header">
            <h2>{{ t("vip.experienceTitle") }}</h2>
            <a
              class="btn-close"
              href="javascript:"
              @click.prevent="onHide('isShowRecord')"
            ></a>
          </header>
          <article class="mask-body">
            <div class="scroll-box">
              <!-- 移动端显示 -->
              <template v-if="isMobile">
                <p class="center" v-if="exprienceList.length < 1">
                  {{ t("vip.errorTips2") }}
                </p>
                <ul class="list-record" v-else>
                  <li v-for="item in exprienceList" :key="item.id">
                    <dl>
                      <dt>{{ t("vip.tableTitle1") }}</dt>
                      <dd>{{ formatDate(item.createDateStr) }}</dd>
                    </dl>
                    <dl>
                      <dt>{{ t("vip.tableTitle2") }}</dt>
                      <dd>{{ item.sourcePathway ? t('vip.' + item.sourcePathway) : '' }}</dd>
                    </dl>
                    <dl>
                      <dt>{{ t("vip.tableTitle3") }}</dt>
                      <dd>{{ item.amount > 0 ? '+' : '-' }}{{ item.amount }}</dd>
                    </dl>
                  </li>
                </ul>
              </template>
              <!-- PC端显示 -->
              <template v-else>
                <table class="table">
                  <thead>
                    <tr>
                    <th>{{ t("vip.tableTitle1") }}</th>
                    <th>{{ t("vip.tableTitle2") }}</th>
                    <th>{{ t("vip.tableTitle3") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="exprienceList.length < 1">
                      <td colspan="3" class="center">
                        {{ t("vip.errorTips2") }}
                      </td>
                    </tr>
                    <tr v-for="item in exprienceList" :key="item.id">
                      <td>{{ formatDate(item.createDateStr) }}</td>
                      <td>{{ item.sourcePathway ? t('vip.' + item.sourcePathway) : '' }}</td>
                      <td>{{ item.amount > 0 ? '+' : '-' }}{{ item.amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount, nextTick, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  loginUserId,
  getVipInfo,
} from "@/api/vipCenter";
import { trackInfo } from "@/api/tracking";
import { isMobileDevice } from "@/utils/currency";

const { t, tm } = useI18n();
const baseUrl = process.env.BASE_URL;

// 基础状态
const isPageReady = ref(false); // 页面是否加载完成
const isAppLoaded = ref(false);
const isLogin = ref(false);
const isLoading = ref(false);
const isMobile = ref(false);
const payCenterURL = ref('/pay-center');
const urlReferrer = new URLSearchParams(window.location.search).get('referrer') || localStorage.getItem('homepage_referrer');
const tipMessage = ref('');
const swiperItemHeight = ref('40px');
const isSwiperLoaded = ref(false);
const swiperInstance = ref(null);
const currentVIPLevel = ref('0');
const vipLevel = ref('0');

// 用户信息
const userInfo = reactive({
  headPic: '',
  roleName: '',
  level: '',
  serverId: '',
  roleID: '',
});

// VIP信息
const currentVipInfo = reactive({
  exprience: 0,
  imgUrl: '',
});

// VIP经验
const currentUserVipExp = ref(0);
const currentProgress = ref('0%');

// 表单数据
const formData = reactive({
  userID: '',
  isShowError: false,
});

// 弹窗状态
const popup = reactive({
  isShowLogin: false,
  isShowLogout: false,
  isShowRecord: false,
});

// 经验记录列表
const exprienceList = ref([]);

// 翻译文本
const htmlText1 = computed(() => tm('vip.htmlText1'));

// 日期格式化函数
const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const i = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${m}-${d} ${h}:${i}:${s}`;
};

// 动态加载样式表并返回 Promise
const loadStyle = (url) => {
  return new Promise((resolve) => {
    const cssId = 'vip-center-css';
    let link = document.getElementById(cssId);
    if (link) {
      resolve();
      return;
    }
    link = document.createElement('link');
    link.id = cssId;
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = () => resolve();
    link.onerror = () => resolve(); // 即使加载失败也继续，避免卡死
    document.head.appendChild(link);
  });
};

let resizeHandler = null;

// 页面初始化
const initPage = async () => {
  isMobile.value = isMobileDevice();
  isLoading.value = true;
  
  try {
    // 1. 先等待样式表加载完成，防止 FOUC
    const cssUrl = `${baseUrl}css/coc-en/vip-center.css`;
    await loadStyle(cssUrl);

    // 2. 检查登录状态
    let token = localStorage.getItem("token");
    const expire = localStorage.getItem("token_expire");
    if (token && expire && Date.now() > parseInt(expire, 10)) {
      localStorage.removeItem("token");
      localStorage.removeItem("token_expire");
      token = null;
    }

    if (token) {
      isLogin.value = true;
      await fetchVipInfo().catch(err => {
        console.error("Get user info failed:", err);
      });

      // 初始化轮播
      initSwiper();
    } else {
      isLogin.value = false;
    }

    isPageReady.value = true;
  } catch (err) {
    console.error("Initialization error:", err);
    tipMessage.value = err.message || "Initialization failed";
  } finally {
    isLoading.value = false;
    // 延迟一小会儿关闭 loading，确保浏览器渲染完成
    setTimeout(() => {
      isAppLoaded.value = true;
    }, 100);
  }
};

// 窗口大小变化处理
const handleResize = () => {
  if (isMobile.value) {
    initSwiper();
  }
};

// 完善轮播初始化逻辑
const initSwiper = () => {
  // 确保Swiper已引入且当前是移动端
  if (window.Swiper && isMobile.value) {
    // 先销毁旧实例，避免重复初始化
    if (swiperInstance.value && typeof swiperInstance.value.destroy === 'function') {
      swiperInstance.value.destroy(true, true);
    }
    
    // 确保DOM已渲染
    nextTick(() => {
      try {
        // 查找轮播容器
        const swiperContainer = document.querySelector('#vipSwiper .swiper');
        if (!swiperContainer) return;
        // 初始化轮播
        swiperInstance.value = new window.Swiper(swiperContainer, {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          initialSlide: Number(vipLevel.value) > 0 ? Number(vipLevel.value) - 1 : 0,
          on: {
            slideChange: () => {
              currentVIPLevel.value = swiperInstance.value.activeIndex + 1;
            },
          },
          autoplay: {
            delay: 2000,
            disableOnInteraction: false
          }
        });

        // 只有在未登录状态下才启用自动播放
        if (!isLogin.value && swiperInstance.value.autoplay) {
          swiperInstance.value.autoplay.start();
        } else if (isLogin.value && swiperInstance.value.autoplay) {
          // 登录状态下定位后停止自动播放
          swiperInstance.value.autoplay.stop();
        }

        // 初始化完成后显示轮播
        isSwiperLoaded.value = true;
      } catch (error) {
        console.error('Init Swiper error:', error);
        isSwiperLoaded.value = true; // 即使失败也显示轮播容器，避免页面空白
      }
    });
  }
};

// 弹窗显示/隐藏
const onShow = (type) => {
  // 在Vue 3中，直接修改响应式对象的属性即可
  popup[type] = true;
  
  // 显示登录弹窗时停止轮播
  if (type === 'isShowLogin' && swiperInstance.value && swiperInstance.value.autoplay) {
    swiperInstance.value.autoplay.stop();
  }
};

const onHide = (type) => {
  popup[type] = false;
  if (type === 'isShowLogin') {
    formData.isShowError = false;
    formData.userID = '';
    tipMessage.value = '';
  }
  
  // 隐藏登录弹窗时恢复轮播（如果未登录状态）
  if (type === 'isShowLogin' && !isLogin.value && swiperInstance.value && swiperInstance.value.autoplay) {
    swiperInstance.value.autoplay.start();
  }
};

// 登录逻辑
const onLogin = async () => {
  if (!formData.userID) {
    formData.isShowError = true;
    tipMessage.value = t('vip.enterID');
    return;
  }
  isLoading.value = true;
  try {
    const res = await loginUserId({
      userID: formData.userID,
      referrer: urlReferrer || document.referrer
    });
    if (res.code === 0) {
      isLogin.value = true;
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("token_expire", Date.now() + 24 * 60 * 60 * 1000);

      onHide('isShowLogin');
      // 登录后获取VIP信息
      await fetchVipInfo();

      // 重新初始化轮播以确保定位到当前VIP等级
      initSwiper();
      // 定位完成后停止滚动播放
      if (swiperInstance.value && swiperInstance.value.autoplay) {
        swiperInstance.value.autoplay.stop();
      }
                  
      // 提示（替换为项目实际的提示组件）
      if (window.$message) {
        window.$message.success(t('vip.loginSuccess'));
      }
    } else {
      formData.isShowError = true;
      tipMessage.value = res.message || t('vip.errorTips1');
    }
  } catch (err) {
    formData.isShowError = true;
    tipMessage.value = err.message || t('vip.errorTips1');
  } finally {
    isLoading.value = false;
  }
};

// 退出登录
const onLogout = () => {
  isLogin.value = false;
  localStorage.removeItem("token");
  localStorage.removeItem("token_expire");
  // 重置用户信息
  Object.keys(userInfo).forEach((key) => {
    userInfo[key] = '';
  });
  onHide('isShowLogout');
  // 退出登录后重新开始自动播放
  if (swiperInstance.value && swiperInstance.value.autoplay) {
    swiperInstance.value.autoplay.start();
  }
  if (window.$message) {
    window.$message.success(t('vip.logoutSuccess'));
  }
};

// 获取VIP信息
const fetchVipInfo = async () => {
  try {
    const res = await getVipInfo({ referrer: urlReferrer || document.referrer });
    if (res.code === 0) {
      Object.assign(currentVipInfo, res.data);
      currentVIPLevel.value = res.data.currentVIPLevel;
      currentUserVipExp.value = res.data.currentUserVipExp;
      vipLevel.value = res.data.vipLevel;
      
      // 计算进度：当前经验 / 下级所需经验
      const exp = parseFloat(res.data.exprience) || 0;
      const currentExp = parseFloat(res.data.currentUserVipExp) || 0;
      const progress = exp > 0 ? Math.min((currentExp / exp) * 100, 100) : 0;
      currentProgress.value = progress + '%';

      // 合并用户信息到响应式对象
      Object.assign(userInfo, res.data);

      // 登录成功后定位到当前VIP等级，停止滚动播放
      if (swiperInstance.value && swiperInstance.value.autoplay) {
        swiperInstance.value.autoplay.stop();
      }
    }
  } catch (err) {
    if (window.$message) {
      window.$message.error(t('vip.getVipInfoFail'));
    }
  }
};

onMounted(async () => {
  await initPage();
  trackInfo('visit');
  
  // 初始化轮播（移动端）
  if (isMobile.value) {
    initSwiper();
  }
  
  // 监听窗口大小变化
  resizeHandler = handleResize;
  window.addEventListener('resize', resizeHandler);
});

onBeforeUnmount(() => {
  // 移除窗口监听
  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler);
  }
  // 销毁轮播实例
  if (swiperInstance.value && typeof swiperInstance.value.destroy === 'function') {
    swiperInstance.value.destroy(true, true);
    swiperInstance.value = null;
  }

  // 清理专属样式表，防止影响其他页面
  const cssLink = document.getElementById('vip-center-css');
  if (cssLink) {
    cssLink.remove();
  }
});
</script>

<style scoped>
/* 防止 Vue 未初始化时的闪烁 */
[v-cloak] {
  display: none !important;
}

/* 优化后的 Loading 样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at center, #2c2c2c 0%, #111111 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.premium-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 226, 155, 0.1);
  border-top-color: #ffe29b;
  border-radius: 50%;
  margin: 0 auto 20px;
  animation: spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.loading-text {
  color: #ffe29b;
  font-size: 16px;
  font-family: "Outfit", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  letter-spacing: 2px;
  margin: 0;
  text-transform: uppercase;
  font-weight: 300;
  opacity: 0.8;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 渐变入场效果 */
.main-content-wrapper {
  animation: fadeIn 0.6s ease-out forwards;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>